module.exports = __webpack_public_path__ + "static/media/engineer.f17ceaae.png";